export const isBase64Image = (data: string): boolean => {
  const base64ImageRegex =
    /^data:image\/(png|jpeg|jpg|gif|bmp|webp|svg\+xml);base64,[A-Za-z0-9+/]+={0,2}$/;
  return base64ImageRegex.test(data);
};
